import React from "react";

// Dependencies
import ChevronDown from "prodigio-icons/web/outlined/ChevronDown";

const DropdownIndicator = () => <ChevronDown width="8" height="4" />;

export default DropdownIndicator;
